module.exports = __webpack_public_path__ + "img/star_charts.e712cd63.png";